import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import PlaySound from 'shared/components/PlaySound';
import { chatSound } from 'globals/assets';

import { getPlay } from './selectors';
import { chatSoundDone } from './actions';

class ChatAppSound extends PureComponent {
  render() {
    const { play, resetPlay } = this.props;

    return <PlaySound url={chatSound} play={play} onFinish={resetPlay} />;
  }
}

ChatAppSound.propTypes = {
  play: PropTypes.bool,
  resetPlay: PropTypes.func,
};

ChatAppSound.defaultProps = {
  play: false,
  resetPlay: () => {},
};

const mapStateToProps = state => ({
  play: getPlay(state),
});

const mapDispatchToProps = dispatch => ({
  resetPlay: () => dispatch(chatSoundDone()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatAppSound);
